<template>
    <transition
        :css="false"
        @before-enter="setSplitText"
        @enter="intro"
        @leave="outro"
    >
        <slot></slot>
    </transition>
</template>

<script>
    import app from '@/app'
    import SplitText from 'gsap/SplitText'
    import {random} from '../../foo/utils/MathUtils.js'

    export default {
        props: {
            introDelay: {
                type: Number,
                default: 0,
            },
            charMinDuration: {
                type: Number,
                default: 0.5,
            },
            charMaxDuration: {
                type: Number,
                default: 1,
            },
            outroDelay: {
                type: Number,
                default: 0,
            },
            outroDuration: {
                type: Number,
                default: 0.75,
            },
        },
        data() {
            return {
                splitText: null,
            }
        },
        methods: {
            setSplitText($el) {
                if (!this.splitText) {
                    this.splitText = new SplitText($el)
                }
                // In case the browser was resized split again.
                if (!this.splitText.isSplit) {
                    this.splitText.split()
                }
            },
            async intro($el, done) {
                const {chars} = this.splitText
                app.resize.add(this.onResize)
                TweenLite.set($el, {alpha: 1})
                const tweens = chars.map(char => this.getIntroTween(char))
                await Promise.all(tweens)
                done()
            },
            outro($el, done) {
                const {outroDelay, outroDuration} = this
                app.resize.remove(this.onResize)
                TweenLite.to($el, outroDuration, {
                    alpha: 0,
                    ease: Sine.easeIn,
                    delay: outroDelay,
                    onComplete: done,
                })
            },
            getIntroTween(char) {
                return new Promise(resolve => {
                    const {charMinDuration, charMaxDuration, introDelay} = this
                    let duration = random(charMinDuration, charMaxDuration)
                    let delay = introDelay + charMaxDuration - duration
                    TweenLite.fromTo(char, duration, {alpha: 0}, {
                        alpha: 1,
                        delay,
                        ease: Sine.easeIn,
                        onComplete: resolve,
                    })
                })
            },
            onResize() {
                const {splitText} = this
                // The divs generated with SplitText will cause trouble if the
                // browser is resized.
                if (splitText && splitText.isSplit) {
                    splitText.revert()
                }
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/app/transitions/TextTransition.vue